// Zinsdelen voor de samenvatting van een herhaling (Engels). Zelfde vorm als recurrenceApp.nl.ts.
export const appRecurrenceEn = {
    once: 'One time',
    everyDay: 'Every day',
    everyWorkday: 'Every weekday',
    everyWeek: 'Every week',
    everyMonth: 'Every month',
    everyYear: 'Every year',
    everyWeekdays: 'Every {days}',
    otherDay: 'Every other day',
    otherWeek: 'Every other week',
    otherMonth: 'Every other month',
    otherYear: 'Every other year',
    nDays: { one: 'Every {count} day', other: 'Every {count} days' },
    nWeeks: { one: 'Every {count} week', other: 'Every {count} weeks' },
    nMonths: { one: 'Every {count} month', other: 'Every {count} months' },
    nYears: { one: 'Every {count} year', other: 'Every {count} years' },
    dailyOnlyOn: '{period}, only on {days}',
    weeklyOn: '{period} on {days}',
    weeklyAllDays: '{period} on all days',
    weeklyWorkdays: '{period} on weekdays',
    monthlyOrdinal: 'Every {ordinals} of the month',
    monthlyOrdinalPeriod: '{period} on the {ordinals}',
    monthlyOn: '{period} on {days}',
    ifWeekday: '{text} if that is a {days}',
    monthDay: 'day {day}',
    lastDay: 'the last day',
    nthLastDay: 'the {ordinal} day',
    yearlyOrdinal: '{period} on the {ordinals} of {months}',
    yearlyOn: '{period} on {date}',
    yearlyDays: '{period} on {days} of {months}',
    dayMonth: '{day} {month}',
    ordinalWeekday: '{ordinals} {weekday}',
    anyWeekday: 'every {weekday}',
    ord1: 'first',
    ord2: 'second',
    ord3: 'third',
    ord4: 'fourth',
    ord5: 'fifth',
    ordLast: 'last',
    ordLast2: 'second-to-last',
    ordLast3: 'third-to-last',
    ordLast4: 'fourth-to-last',
    ordLast5: 'fifth-to-last',
    ordN: 'number {n}',
    evenWeeks: '{text} in even weeks',
    oddWeeks: '{text} in odd weeks',
    at: '{text} at {time}',
    fromTo: '{text} from {start} to {end}',
    times: { one: '{text}, once', other: '{text}, {count} times' },
    until: '{text}, until {date}',
    listAnd: '{a} and {b}',
    listSep: ', ',
};
//# sourceMappingURL=recurrenceApp.en.js.map